import { ApplicationConfig } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideAuth0 } from "@auth0/auth0-angular";
import { environment } from "../environments/environment";

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimationsAsync(),
        provideAuth0(environment.auth0)
    ]
};
